import { isSubAccountEmbedSession } from 'v2/shared/utils/embed-session'
import type { FlowData } from '../../types'
import { isLegacyReadOnly } from '../../utils'

// The flow a read-only legacy agent's Duplicate copies, if it is offered. Duplicating goes through
// clone, which hodor refuses to sub-account embed sessions.
export const legacyDuplicateFlowId = (phlo?: FlowData['phlo']) =>
  isLegacyReadOnly(phlo) && !isSubAccountEmbedSession() ? phlo?.id : undefined
